import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)


export default new VueRouter({
    routes: [{
        path: '/',
        meta: {
            title: '意卡米诺'
        },
        component: () =>
            import ("../components/HelloWorld")
    }, {
        path: '/search',
        meta: {
            title: '搜索结果'
        },
        component: () =>
            import ("../components/searchPage")
    }, {
        path: '/texts',
        meta: {
            title: '协议'
        },
        component: () =>
            import ("../components/textsPage")
    }, {
        path: '/type',
        meta: {
            title: '分类'
        },
        component: () =>
            import ("../components/shop_typePage")
    }, {
        path: '/shopcar',
        meta: {
            title: '购物车'
        },
        component: () =>
            import ("../components/shopCar")
    }, {
        path: '/seeding',
        meta: {
            title: '种草'
        },
        component: () =>
            import ("../components/seeDing")
    }, {
        path: '/seeDingDetail',
        meta: {
            title: '详情'
        },
        component: () =>
            import ("../components/seeDingDetail")
    }, {
        path: '/seckill',
        meta: {
            title: '限时秒杀'
        },
        component: () =>
            import ("../components/secKill")
    }, {
        path: '/new',
        meta: {
            title: '新品专区'
        },
        component: () =>
            import ("../components/newPage")
    }, {
        path: '/coupon',
        meta: {
            title: '领券中心'
        },
        component: () =>
            import ("../components/couponPage")
    }, {
        path: '/shoppingdet',
        meta: {
            title: '商品详情'
        },
        component: () =>
            import ("../components/shoppingDet")
    }, {
        path: '/pay_order',
        meta: {
            title: '下单页'
        },
        component: () =>
            import ("../components/payOrder")
    }, {
        path: '/payment',
        meta: {
            title: '支付'
        },
        component: () =>
            import ("../components/paymentPage")
    }, {
        path: '/vip',
        meta: {
            title: '支付'
        },
        component: () =>
            import ("../components/vipPage")
    }, {
        path: '/user',
        meta: {
            title: '个人中心'
        },
        component: () =>
            import ("../components/userPage")
    }, {
        path: '/diy',
        meta: {
            title: 'DIY定制'
        },
        component: () =>
            import ("../components/diyPage")
    }, {
        path: '/customizedDet',
        meta: {
            title: '定制款式详情'
        },
        component: () =>
            import ("../components/diyCustomizedDet")
    }, {
        path: '/workDet',
        meta: {
            title: '作品详情'
        },
        component: () =>
            import ("../components/diyWorksDet")
    }, {
        path: '/diy_details',
        meta: {
            title: '开始制作'
        },
        component: () =>
            import ("../components/diyDetails")
    }, {
        path: '/diy_shopdetaile',
        meta: {
            title: '开始制作'
        },
        component: () =>
            import ("../components/diyShopdetaile")
    }, {
        path: '/points_shopp_det',
        meta: {
            title: '积分商品详情'
        },
        component: () =>
            import ("../components/points_shopp_det")
    }, {
        path: '/points_pay',
        meta: {
            title: '积分商品下单'
        },
        component: () =>
            import ("../components/pointsPay")
    }]
})